import { createContext, useContext } from "react"

export interface GlobalSearchInputContextValue {
  inputValue: string
  onInputValueChange: (value: string) => void
}

const GlobalSearchInputContext = createContext<
  GlobalSearchInputContextValue | undefined
>(undefined)

export { GlobalSearchInputContext }

export function useGlobalSearchInputContext(): GlobalSearchInputContextValue {
  const context = useContext(GlobalSearchInputContext)
  if (!context) {
    throw new Error(
      "useGlobalSearchInputContext must be used within a GlobalSearch"
    )
  }
  return context
}
